import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingWrapper = () => {
  return (
    <div style={{ margin: 'auto', textAlign: 'center', marginTop: '10%' }}>
      <CircularProgress disableShrink />
    </div>
  );
};
export default LoadingWrapper;


